import type { To } from 'react-router';
import { useNavigation } from 'react-router';

import type { Props } from '#src/atoms/buttons/LoadingButton/index.tsx';
import { LoadingButton } from '#src/atoms/buttons/LoadingButton/index.tsx';

export const NavigatingButton = ({
  to,
  ...props
}: Omit<Props, 'loading'> & { to: To }) => {
  const navigation = useNavigation();

  return (
    <LoadingButton
      to={to}
      {...props}
      loading={navigation.location?.pathname === to}
    />
  );
};
